import React, { useEffect, useState } from 'react';
import { Hero } from './components/Hero';
import { Benefits } from './components/Benefits';
import { Services } from './components/Services';
import { Footer } from './components/Footer';
import { AgencyPopup } from './components/AgencyPopup';
function App() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [hasPopupShown, setHasPopupShown] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (hasPopupShown) return;
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      // Calculate scroll percentage
      const scrollPercentage = scrollPosition / (documentHeight - windowHeight);
      // Show popup when scrolled exactly halfway (50%)
      if (scrollPercentage >= 0.5) {
        setIsPopupOpen(true);
        setHasPopupShown(true);
      }
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    // Check initial scroll position in case user refreshes halfway down
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, [hasPopupShown]);
  return <div className="min-h-screen bg-white" data-id="element-0">
      <Hero data-id="element-1" />
      <Benefits data-id="element-2" />
      <Services data-id="element-3" />
      <Footer data-id="element-4" />

      <AgencyPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} data-id="element-5" />
    </div>;
}
export { App };